import React from 'react';
import { func, string, bool, shape } from 'prop-types';
import { Tooltip, IconButton } from '@ublend-npm/aulaui-next';
import EditIcon from '@material-ui/icons/Edit';
import { DISCUSSION_TOPIC_EDIT } from '../../../../../../../constants/texts';
import {
  Title,
  TitleContainer,
  IconButtonContainer,
  DiscussionDetailsContainer,
  VisibilityOffIcon,
} from './DiscussionDetailsCard.styled';

const EditDiscussionCard = ({
  showDiscussion,
  discussionTopic,
  openDiscussionTopicModal,
  discussionPermission,
}) => {
  const { allowed, message } = discussionPermission;
  const handleClick = () => {
    if (!allowed) {
      return;
    }
    openDiscussionTopicModal();
  };

  return (
    <>
      <TitleContainer>
        {!showDiscussion && (
          <DiscussionDetailsContainer>
            <VisibilityOffIcon />
            Hidden from students
          </DiscussionDetailsContainer>
        )}
        <Title isMediumGrey={!showDiscussion}>{discussionTopic}</Title>
      </TitleContainer>
      <Tooltip
        title={allowed ? DISCUSSION_TOPIC_EDIT : message}
        position="top"
        disabled={allowed}
      >
        <IconButtonContainer>
          <IconButton
            type="secondary"
            onClick={handleClick}
            label="edit"
            size="small"
            data-testid="edit-discussion-button"
            icon={EditIcon}
            disabled={!allowed}
          />
        </IconButtonContainer>
      </Tooltip>
    </>
  );
};

EditDiscussionCard.propTypes = {
  openDiscussionTopicModal: func.isRequired,
  discussionTopic: string,
  showDiscussion: bool,
  discussionPermission: shape({
    allowed: bool,
    message: string,
  }),
};

EditDiscussionCard.defaultProps = {
  discussionTopic: '',
  showDiscussion: false,
  discussionPermission: { allowed: true },
};

export default EditDiscussionCard;
